
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Visualizations',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Enter a number',
	'maxValuePlaceholder': 'Enter a number',
	'customRangeErrorMessage': 'Value must be a number',
	'propFillColor': 'Fill color',
	'propBorderColor': 'Border color',
	'propBorderRadius': 'Corner radius (px)',
	'propColorPalette': 'Current color palette',
	'propColorPaletteChangeLabel': 'Change color palette',
	'propNewColorPaletteLabel': 'Create a custom color palette',
	'propNewHeatPaletteLabel': 'Create a custom heat palette',
	'showTitleLabel': 'Show title',
	'titleTypeLabel': 'Title type',
	'smartTitleLabel': 'Smart title',
	'customTitleLabel': 'Custom title',
	'noTitleLabel': 'No title',
	'colorPaletteTitle': 'Palette',
	'responsiveTitleLabel': 'Responsive title',
	'propHeatScalePalette': 'Current heat palette',
	'propHeatPaletteChangeLabel': 'Change heat palette',
	'propMaintainAxisScales': 'Maintain axis scale',
	'propLineAndSymbolColor': 'Line and symbol color',
	'propLineAndSymbolPalette': 'Line and symbol color palette',
	'propElementColor': 'Element color',
	'propColumnColor': 'Column color',
	'propColumnPalette': 'Column color palette',
	'propColumnHeatPalette': 'Column heat palette',
	'propBarColor': 'Bar color',
	'propGoalColor': 'Target color',
	'propToColor': 'To color',
	'propFromColor': 'From color',
	'propNumberValidationErrorMessageId': 'Enter a number',
	'fontSizeAuto': 'Auto',
	'propAutoBinCount': 'Number of groups',
	'propAutoBinToggle': 'Auto-grouping',
	'tabName_general': 'General',
	'tabName_visDetails': 'Details',
	'tabName_animation': 'Animation',
	'tabName_mediaDetails': 'Media details',
	'tabName_webDetails': 'Web page details',
	'tabName_imageDetails': 'Image details',
	'tabName_visualization': 'Visualization',
	'tabName_text': 'Text',
	'sectionName_colorsAndThemes': 'Color and themes',
	'sectionName_appearance': 'Appearance',
	'sectionName_general': 'General',
	'sectionName_colorPalette': 'Color',
	'sectionName_axis': 'Axis',
	'sectionName_axis_label': 'Axis',
	'sectionName_legend': 'Legend',
	'sectionName_chart': 'Chart',
	'sectionName_regionLayer': 'Regions layer',
	'sectionName_pointLayer': 'Points layer',
	'sectionName_latLongLayer': 'Latitude/longitude layer',
	'sectionName_pathLayer': 'Path layer',
	'sectionName_xAxis': 'X axis',
	'sectionName_yAxis': 'Y axis',
	'sectionName_xAxis_title': 'X axis title',
	'sectionName_yAxis_title': 'Y axis title',
	'sectionName_xAxis_label': 'X axis label',
	'sectionName_yAxis_label': 'Y axis label',
	'sectionName_column_yAxis': 'Column Y axis',
	'sectionName_column_yAxis_label': 'Column Y axis label',
	'sectionName_column_yAxis_title': 'Column Y axis title',
	'sectionName_line_yAxis': 'Line Y axis',
	'sectionName_line_yAxis_label': 'Line Y axis label',
	'sectionName_line_yAxis_title': 'Line Y axis title',
	'sectionName_title': 'Title',
	'sectionName_legendTitle': 'Legend title',
	'sectionName_legendLabels': 'Legend labels',
	'sectionName_innerValueLabel': 'Inner value label',
	'sectionName_style': 'Style',
	'propTransparencyDescription': 'Make the object more or less transparent. Type in a value between 0 and 100',
	'smart_annotation_unauthorized': 'Annotations: unauthorized access',
	'smart_annotation_method': 'Annotations: method not allowed',
	'smart_annotation_media': 'Annotations: media type not allowed',
	'smart_annotation_input': 'Annotations: input invalid',
	'smart_annotation_internal': 'Annotations: internal system error',
	'smart_annotation_generic_error': 'Annotations: service error',
	'smart_annotation_dialog_title': 'Insights',
	'smart_annotation_Show_Insights': 'Show insights',
	'smart_annotation_Relationship': 'The relationship is',
	'forecast_enter_number': 'Enter a number between ',
	'and': ' and ',
	'smart_errors': 'Annotation errors:',
	'smart_warnings': 'Annotation warnings:',
	'smart_annotation_insight_icon_title': 'Insights',
	'smart_annotations_toggle_on': 'Toggle insights on',
	'smart_annotations_toggle_off': 'Toggle insights off',
	'smart_annotation_toggle_on': 'Toggle on',
	'smart_annotation_toggle_off': 'Toggle off',
	'smart_annotation_insight_unavailable': 'Insights are currently not available',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Insights are not available when a Top or Bottom % filter is applied',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Forecast is not available when a Top or Bottom % filter is applied',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Insights are not available when a top or bottom filter is applied and there is more than one column in the field',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Forecast is not available when a top or bottom filter is applied and there is more than one column in the field',
	'forecast_title': 'Forecast',
	'forecast_show': 'Show forecast',
	'forecast_toggle_on': 'Toggle forecasting on',
	'forecast_toggle_off': 'Toggle forecasting off',
	'statDetails_title': 'See statistical details',
	'forecast_optional_factors_max_info': 'Maximum of %{max} factors can be added',
	'forecast_optional_factors_num_added': '%{added}/%{max}',
	'forecast_optional_factors': 'Optional factors to consider',
	'forecast_optional_factors_placeholderDropzone': 'Click or drag data here',
	'forecast_item_tooltip': 'Source:',
	'insightsNarrator': 'Narrative insights',
	'statDetailsPerspectiveTitle': 'Analysis',
	'emptyStatDetailsPanel': 'No additional analysis is available for the current visualization.',
	'predict_errors': 'Analysis errors',
	'predict_warnings': 'Analysis warnings',
	'fpd_invalid_data_source': 'This data source does not have an associated smarts module',
	'fpd_network_issue': 'There was an issue performing an analysis against this data source',
	'fpd_data_source_category': 'Smarts module missing',
	'fpd_response_errors': 'Recommended driver errors',
	'fpd_response_warnings': 'Recommended driver warnings',
	'catalyst_service_bad_request': 'Bad request',
	'catalyst_service_unkown_Id': 'Unknown request ID found',
	'catalyst_service_internal_server_error': 'Internal Server Error',
	'catalyst_service_generic_error': 'Catalyst service error',
	'catalyst_service_error': 'This service is not currently available',
	'propLegendPosition': 'Legend position',
	'propLeft': 'Left',
	'propRight': 'Right',
	'propTop': 'Top',
	'propBottom': 'Bottom',
	'propNone': 'None',
	'propLegendDisplay': 'Display legend',
	'targetThicknessPlaceHolder': '%{min} to %{max}',
	'targetThicknessErrorMsg': 'Enter a whole number between %{min} and %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Drivers (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'selected)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Reset to defaults',
	'possibelKeyDriver_AddNewDrivers': 'Add more drivers',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Search to add more drivers',
	'possibleKeyDrivers_MaxPossibleReached': 'Deselect some drivers to add or select others',
	'possibleKeyDrivers_Recommended': 'Recommended',
	'visRecommendedTypes': 'Recommended visualization types',
	'visRecommender_smartsfailure': 'visualization recommendations are not currently available',
	'visMore': 'More...',
	'visMoreTooltip': 'More visualizations',
	'visOtherTypes': 'Other visualization types',
	'visChange': 'Change visualization',
	'automaticTypeCaption': 'Automatic',
	'propVisType': 'Visualization types',
	'dlg_loading': 'Loading...',
	'snippetListChartCaption': 'Snippet list',
	'convoClusterChartCaption': 'Conversation cluster',
	'areaChartCaption': 'Area',
	'barChartCaption': 'Bar',
	'columnChartCaption': 'Column',
	'stackedbarChartCaption': 'Stacked bar',
	'stackedcolumnChartCaption': 'Stacked column',
	'bubbleChartCaption': 'Bubble',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Driver analysis',
	'scatterChartCaption': 'Scatter',
	'lineChartCaption': 'Line',
	'pointChartCaption': 'Point',
	'heatChartCaption': 'Heat map',
	'bulletChartCaption': 'Bullet',
	'waterfallChartCaption': 'Waterfall',
	'radarChartCaption': 'Radar',
	'boxplotChartCaption': 'Box plot',
	'pieChartCaption': 'Pie',
	'mapChartCaption': 'Map',
	'radialBarChartCaption': 'Radial',
	'compositeChartCaption': 'Line and column',
	'wordCloudChartCaption': 'Word cloud',
	'networkChartCaption': 'Network',
	'relationshipNetworkChartCaption': 'Relationship network',
	'treemapChartCaption': 'Tree map',
	'packedBubbleChartCaption': 'Packed bubble',
	'hierarcicalPackedBubbleChartCaption': 'Hierarchy bubble',
	'spiralChartCaption': 'Spiral',
	'decisionTreeChartCaption': 'Decision tree',
	'legacyMapChartCaption': 'Legacy map',
	'sunburstChartCaption': 'Sunburst',
	'visUsageComparison': 'Comparison',
	'visUsageRelationships': 'Relationships',
	'visUsageTrend': 'Trend',
	'visUsagePartsToWhole': 'Parts to whole',
	'visUsageGeospatial': 'Geospatial',
	'visUsageAdvanced': 'Advanced analytics',
	'visUsageTablesAndSummary': 'Tables and summary',
	'visUsageSocialInsights': 'Social insights',
	'visUsageOther': 'Other',
	'visualizationAnalytics': 'Analytics',
	'autoBinActionText': 'Auto-group',
	'filterAutobinActionText': 'Filter bins',
	'memberCalculationActionText': 'Member Calculation',
	'toolbarActionCalculation': 'Create calculation',
	'toolbarActionEditCalculation': 'Edit calculation',
	'topBottomRankLabel': 'Rank (%{label})',
	'toolbarDeleteFilterActionText': 'Remove filter',
	'toolbarActionTopKeyDrivers': 'Show drivers',
	'toolbarActionCustomGroup': 'Custom group',
	'canNotCreateCustomGroup': 'We cannot create this custom group.',
	'aria_label_datatable': 'Data table',
	'summaryCaption': 'Summary',
	'MeasuresCaption': 'Measures',
	'MeasuresGroupCaption': 'Measures group (%{count})',
	'ValuesCaption': 'Values',
	'turnInsightsOn': 'Turn insights on',
	'turnInsightsOff': 'Turn insights off',
	'decisionRules': 'Rules',
	'decisionTree': 'Tree diagram',
	'decisionSunburst': 'Tree sunburst',
	'switchToDecisionRules': 'Switch to decision rules',
	'switchToDecisionTree': 'Switch to decision tree',
	'data_group_less_then': 'less than %{rangeTo}',
	'data_group_to': '%{rangeFrom} to < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} and above',
	'nullValueContent': '(no value)',
	'sum': 'Sum',
	'count': 'Count',
	'countdistinct': 'Count distinct',
	'avg': 'Average',
	'min': 'Minimum',
	'max': 'Maximum',
	'automatic': 'Custom',
	'variance': 'Variance',
	'stddev': 'Standard Deviation',
	'median': 'Median',
	'calculated': 'Calculated',
	'none': 'None',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Prompt values',
	'inputLabelPrompt': 'Value',
	'inputPlaceholderPrompt': 'Enter value',
	'inputInvalidText': 'Invalid input for %{dataType} type',
	'unSupportedPrompt': 'Unsupported prompt',
	'missingDataSource': 'Could not find the right data source.',
	'unSupportedPromptType': 'The prompt scenario is not currently supported.',
	'preAggregateLabel': 'Apply prompt values from the data source',
	'postAggregateLabel': 'Apply prompt values in the report',
	'preAggregateText': 'The range uses the values in the data source, not the values displayed in the dashboard.',
	'defaultAggregation_count': 'Count',
	'defaultAggregation_countdistinct': 'Count distinct',
	'defaultAggregation_max': 'Maximum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Average',
	'defaultAggregation_sum': 'Sum',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',
	'keydriver_average': 'Overall average',
	'keydriver_up_down': 'Highlighted groups with high or low averages have more impact on the target. Groups with unusually high or low averages have the strongest impact.',
	'keydriver_different': 'Highlighted groups have distributions that differ significantly from the overall distribution. These groups have more impact on the target.',
	'topOperator': 'Top',
	'bottomOperator': 'Bottom',
	'topBottomFact': '%{operator} %{value}%{percent} by %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Delete top or bottom count',
	'deleteTopBottomPercent': 'Delete top or bottom %',
	'topBottomTitle': 'This object only',
	'deleteTopBottom': 'Delete top or bottom count',
	'editTopBottom': 'Edit top or bottom count',
	'editTopBottomCount': 'Edit top or bottom count',
	'editTopBottomPercent': 'Edit top or bottom %',
	'deleteDrillOperation': 'Cancel drill operation',
	'ariaDeleteTopBottomCountLabel': 'Press DELETE key to delete top or bottom count.',
	'ariaDeleteTopBottomPercentLabel': 'Press DELETE key to delete top or bottom %.',
	'ariaEditTopBottomCountLabel': 'Press ENTER key to edit top or bottom count.',
	'ariaEditTopBottomPercentLabel': 'Press ENTER key to edit top or bottom %.',
	'ariaDeleteDrillStateLabel': 'Press ENTER key to edit drill operation.',
	'drillUpStateTitle': 'Drill up',
	'drillDownStateTitle': 'Drill down',
	'ariaEditTopBottomLabel': 'Press ENTER key to edit top or bottom count.',
	'ariaDeleteTopBottomLabel': 'Press DELETE key to delete top or bottom count.',
	'allKeyDriversLabel': 'Auto (all drivers)',
	'filter_drag_and_drop_single_dock': 'Drag and drop data here to filter.',
	'filter_drag_and_drop_all_tabs': 'Drag and drop data here to filter all tabs.',
	'filter_drag_and_drop_current_tab': 'Drag and drop data here to filter this tab.',
	'filter_empty_consume_mode': 'No filters have been applied.',
	'filterClearAllItems': 'Clear all filters',
	'filterDeleteAllItems': 'Delete all filters',
	'filterDockChevronLeft': 'Scroll through the data',
	'filterDockChevronRight': 'Scroll through the data',
	'filterIconLabel_Single': 'Filters',
	'filterIconLabel_Global': 'All tabs',
	'filterIconLabel_Tab': 'This tab',
	'filterIconTooltip_Single': 'Filters',
	'filterIconTooltip_Global': 'Filters for all tabs',
	'filterIconTooltip_Tab': 'Filters for this tab',
	'filterDropZoneTooltip_Single': 'Filter drop zone',
	'filterDropZoneTooltip_Global': 'Filter drop zone for all tabs',
	'filterDropZoneTooltip_Tab': 'Filter drop zone for this tab',
	'filterOverflowMenu': 'More',
	'expand': 'Expand',
	'collapse': 'Collapse',
	'filterDockItemNameAriaLabel': 'Press enter to launch the filter dialog and define the filter.',
	'filterItemCanvasMove': 'Add to canvas',
	'addToCascadeSet': 'Add to cascade set',
	'removeFromCascadeSet': 'Remove from cascade set',
	'filterItemDelete': 'Delete filter',
	'filterInvertRange': 'everything except: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Not after %{from}',
	'filter_date_after': 'After %{from}',
	'filter_date_before_except': 'Not before %{to}',
	'filter_date_before': 'Before %{to}',
	'filter_date_between_except': 'Not between %{from}-%{to}',
	'filter_date_between': 'Between %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'All',
	'filter': 'Filter',
	'filterExcept': 'except %{values}',
	'filterDockToolbarButtonLabel': 'Filter dock',
	'navigateTitle': 'Navigate to',
	'navigateSelectColumn': 'Select a column',
	'navigateSelectPath': 'Select a navigation path',
	'current_nav_group': 'Current navigation group is %{navigation_group_name}',
	'next': 'Next',
	'previous': 'Previous',
	'multiselectMsg': '%{count} selected',
	'errMsgFilterItemMissingTitle': 'The filter value(s) %{itemName} cannot be loaded because these values are not available with this data set',
	'errMsgFilterItemGenericTitle': 'Filter values can\'t be loaded',
	'textFilterItemsNotFound': 'No items are available.',
	'nullValueLabel': '(blank)',
	'filterConditionLabel': 'Filter condition',
	'filter_includesAll': 'Includes all',
	'filter_allMembersOfSet': 'All members of the set',
	'modelFilter': 'Filter',
	'filtersTitle': 'Filter properties',
	'search': 'Search',
	'clearTextFilterValue': 'Clear',
	'invertFilterSelection': 'Invert',
	'modellingLoading': 'Loading...',
	'searchAll': 'Find all columns',
	'toolbarActionPossibleKeyDrivers': 'Edit scope',
	'toolbarActionPossibleKeyDriversSubTitle': 'Drag items from the left to be considered in the driver analysis chart',
	'toolbarActionSort': 'Sort',
	'toolbarActionSortAscending': 'Ascending',
	'toolbarActionSortDescending': 'Descending',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionSortCustom': 'Custom',
	'toolbarActionFormat': 'Format data',
	'toolbarActionFormatText': 'Format data (text)',
	'toolbarActionFormatAbbreviation': 'Abbreviate',
	'toolbarActionFormatNone': 'Auto',
	'toolbarActionFilter': 'Filter',
	'toolbarActionTopBottom': 'Top or bottom',
	'toolbarActionRmvShape': 'Remove shape',
	'toolbarActionToggleShapeDrop': 'Infographic shape',
	'toolbarActionToggleShapeDropTitle': 'Create an infographic',
	'toolbarActionToggleShapeDropText': 'Drag a shape to this field to create an infographic.',
	'toolbarActionAggregationType': 'Summarize',
	'toolbarDeleteActionText': 'Remove column',
	'toolbarTextActionText': 'Style text',
	'toolbarActionFilterLocalKeepSelected': 'Keep',
	'toolbarActionFilterLocalExcludeSelected': 'Exclude',
	'toolbarActionFilterAllKeepSelected': 'Filter',
	'toolbarActionSimpleCalculation': 'Simple calculation',
	'toolbarActionDrillBack': 'Back',
	'toolbarActionDrillUp': 'Drill up',
	'toolbarActionDrillDown': 'Drill down',
	'toolbarActionJumpTo': 'Drill through',
	'toolbarActionNavigate': 'Navigate',
	'toolbarActionCreateFilterGroup': 'Create new connection',
	'toolbarActionDisconnectFilterGroup': 'Break all links',
	'toolbarActionLinkFilterGroup': 'Add to an existing connection',
	'toolbarActionLassoSelect': 'Select tool',
	'toolbarActionRefreshDeveloperWidget': 'Refresh',
	'textFontFamilySubClassHairline': 'Hairline',
	'textFontFamilySubClassThin': 'Thin',
	'textFontFamilySubClassThinItalic': 'Thin Italic',
	'textFontFamilySubClassExtraLight': 'Extra Light',
	'textFontFamilySubClassExtraLightItalic': 'Extra Light Italic',
	'textFontFamilySubClassLight': 'Light',
	'textFontFamilySubClassLightItalic': 'Light Italic',
	'textFontFamilySubClassRegular': 'Regular',
	'textFontFamilySubClassRegularItalic': 'Regular Italic',
	'textFontFamilySubClassItalic': 'Italic',
	'textFontFamilySubClassMedium': 'Medium',
	'textFontFamilySubClassMediumItalic': 'Medium Italic',
	'textFontFamilySubClassHeavy': 'Heavy',
	'textFontFamilySubClassHeavyItalic': 'Heavy Italic',
	'textFontFamilySubClassDemiBold': 'Demi Bold',
	'textFontFamilySubClassDemiBoldItalic': 'Demi Bold Italic',
	'textFontFamilySubClassBold': 'Bold',
	'textFontFamilySubClassBoldItalic': 'Bold Italic',
	'textFontFamilySubClassExtraBold': 'Extra Bold',
	'textFontFamilySubClassExtraBoldItalic': 'Extra Bold Italic',
	'textFontFamilySubClassBlack': 'Black',
	'textFontFamilySubClassBlackItalic': 'Black Italic',
	'textFontFamilySubClassStencil': 'Stencil',
	'dlg_ascending': 'ascending',
	'dlg_descending': 'descending',
	'dlg_custom': 'custom',
	'dlg_none': 'none',
	'dlg_hierarchy': 'hierarchy',
	'dlg_namedSet': 'named set',
	'dlg_rank': 'rank',
	'visualizationLabel': 'Visualization',
	'chartLabel': '%{chartName} chart',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Press F12 to navigate within the widget',
	'f10KeyDescription': 'Press F10 to launch the widget focus view',
	'playButtonLabel': 'Play',
	'dataPlayerValueListLabel': 'Data player values',
	'localFilterTitle': 'This object only',
	'globalFilterTitle': 'All objects',
	'deleteFilter': 'Delete filter',
	'editFilter': 'Edit filter',
	'ariaEditFilterLabel': 'Press ENTER key to edit filter.',
	'ariaDeleteFilterLabel': 'Press DELETE key to delete filter.',
	'measureFilterBetween': 'Between %{lowerBound} and %{upperBound}',
	'measureFilterNotBetween': 'Not between %{lowerBound} and %{upperBound}',
	'dimFilterIn': 'Includes: %{in}',
	'dimFilterNotIn': 'Excludes: %{out}',
	'gtFilter': 'Greater than %{lowerBound}',
	'afterFilter': 'After %{lowerBound}',
	'beforeFilter': 'Before %{upperBound}',
	'gteFilter': 'Greater than or equal to %{lowerBound}',
	'ltFilter': 'Less than %{upperBound}',
	'lteFilter': 'Less than or equal to %{upperBound}',
	'ariaEditPrompt': 'Press ENTER key to change the prompt value',
	'dataPointFilterTitle': 'Data points',
	'dataPointFilterIncludeSummary': 'Included %{valueCount} data points',
	'dataPointFilterExcludeSummary': 'Excluded %{valueCount} data points',
	'widgetFiltersLabel': 'Widget filters',
	'coachMarkTitleSpiralTarget': 'Edit scope',
	'coachMarkContentSpiralTarget': 'This is where you can access and modify the driver selection for your target.',
	'srILVTreeLabel': 'List',
	'geomapUnrecognizedLocations': 'Unrecognized locations:',
	'geomapAmbiguousLocations': 'Ambiguous regions:',
	'visualizationNotifications': 'Visualization notifications:',
	'dataNotifications': 'Data notifications:',
	'autobinSuggestion': 'Turn on auto-grouping',
	'LIVE_empty_visualization_hint_title': 'Build your visualization',
	'LIVE_empty_visualization_hint_description': 'Drag data here or onto the fields.',
	'LIVE_slots_required_field_description': '%{asterisk} Indicates a required field',
	'LIVE_slots_drag_and_drop_description': 'Drag and drop data to the fields above to build and filter the visualization.',
	'tooltipSlotDefaultCaption': 'Tooltip',
	'tooltipSlotCompositeLineCaption': 'Line tooltip',
	'tooltipSlotCompositeColumnCaption': 'Column tooltip',
	'dwErrorLoadingAvailableVisualizations': 'We can\'t load the available visualization definitions',
	'moreDataIndicator': 'Your data was clipped at %{threshold} items. Apply a filter to show less.',
	'nonCtxTopBottomInvalid': 'Defining a top or bottom rule without a context is not supported for crosstabs. It was removed from this crosstab view.  Redefine the rule on one or more categories in the context of %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'We can\'t load the object, because it is missing a visualization definition.',
	'dwErrorLoadingVisualizationListNotFound': 'We can\'t load the visualization.',
	'dwErrorRunningQuery': 'We can\'t retrieve the data from data set %{datasetName}.',
	'dwErrorGeoData': 'We\'re having trouble displaying the geographic data in a map. Please choose another visualization type.',
	'dwPromptSignonCancelWarning': 'The data for this visualization is unavailable. Please provide the correct credentials.',
	'dwErrorMissingDataset': 'We can\'t load the visualization, because its associated data set "%{datasetName}" isn\'t available.',
	'dwErrorRenderingVisualization': 'We can\'t load this visualization.',
	'dwErrorVisualizationTooSmall': 'The visualization is too small to display the data it contains. Make the visualization larger or limit the data it contains.',
	'errorSourceNotFound': 'We can\'t load the visualization, because its associated source "%{sourceName}" isn\'t available.',
	'errorActionNotSupported': 'This action is not supported for data source "%{sourceName}".',
	'errorMeasureNotSupportedOnMultiEdges': 'The visualization has measures on multiple edges, which is no longer supported. Please place measures on only one edge.',
	'errorExceedAllowableValue': 'The estimated number of cells exceeds the allowable value of 100000. Please apply filtering to projected sets to reduce the number of cells.',
	'propScaleLabel': 'Quantity of icons',
	'propScaleDescription': 'Select the quantity of icons',
	'propScaleFew': 'Low',
	'propScaleDefault': 'Default',
	'propScaleMany': 'High',
	'lastRefresh': 'Last refresh: %{timeInterval} ago',
	'widgetTimer': 'Widget timer',
	'datasetItemsUnavailable': 'Some data set items used in this visualization are unavailable.',
	'datasetItemUnavailable': 'This data set item is unavailable',
	'retry': 'Retry',
	'widgetConditionalFormatLabel': 'Toggle conditional format controls',
	'widgetConditionalFormatTitle': 'Edit conditional formatting color',
	'crosstabName': 'Crosstab',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'N/A',
	'summaryLabel': '%{label} with value %{value}',
	'infographicLabel': '%{label} with value %{value}',
	'warning': 'Warning',
	'swapRowsAndColumns': 'Swap rows and columns',
	'hideSummariesLabel': 'Hide summaries',
	'showSummariesLabel': 'Show summaries',
	'hideRowColumn': 'Hide',
	'showAllRowColumn': 'Show all',
	'dataAssetPropertiesLabel': 'Visualization properties',
	'evAdd': 'Add a column',
	'evCollapse': 'Collapse',
	'evColumns': 'Columns',
	'evLocalFilters': 'Local filters',
	'evExpand': 'Expand',
	'evFilterTooltip': 'Filter',
	'missingColumn': 'Missing: %{columnLabel}',
	'missingFiltering': 'Missing filters on columns:',
	'missingDataItem': 'The referenced data item "%{dataItemId}" is not found in the widget.',
	'heatByLabel': 'Heat by',
	'toolbarChangeVisualization': 'Change visualization',
	'modellingRelatedTablesNoneFound': 'No related tables found',
	'tablesNotJoined': 'Relationships between tables are not defined.',
	'fixTableJoin_edit': 'View relationships',
	'processing': 'Processing...',
	'errorCellWarning': 'Some summary values could not be calculated.',
	'aggregateTypeToggler': 'Show aggregation type',
	'maxColumnsExceeded': 'Maximum number of columns exceeded. %{columns} dropped.',
	'unboundColumns': 'Unable to use the following columns: %{columns}.',
	'unboundColumn': 'Unable to use the following column: %{columns}.',
	'recommendRequestFailed': 'Recommendation request failed. Please contact your administrator.',
	'visualizationDoesNotSupportOLAP': 'We cannot create this visualization that is based on an OLAP data source. Please use another supported data source.',
	'showDataBehindVizLabel': 'Show data',
	'showDataBehindVizNotSupportedLabel': 'Show data is not supported for this visualization type',
	'exploreData': 'Explore ...',
	'newExplore': 'New Exploration',
	'thumbnails_error_fetching': 'Error fetching thumbnails',
	'loadedThumbnailImage': 'Loaded %{visType} visualization thumbnail image',
	'autobinAxisLabel': 'groups',
	'recommended_visualizations': 'Recommended visualizations',
	'all_visualizations': 'All visualizations',
	'edit': 'Edit',
	'selectTargetDialogTitle': 'Select a drill-through target',
	'noTargetInCM': 'Unable to find the target of the drill-through',
	'errorDrillDefinition': 'Something went wrong while you were adding or editing the drill-through definition.',
	'errorDrillToTarget': 'An error occurred to drill to "%{targetName}"',
	'drillThroughMappingViewLabel': 'Assign columns from your dashboard to the prompts of the target report',
	'drillthroughScopeRadioLabel': 'Apply this definition to:',
	'drillthroughScopeRadioOptionVisualization': 'This visualization only',
	'drillthroughScopeRadioOptionConnection': 'Visualizations in the same connection that use the same data source',
	'drillthroughScopeRadioOptionDashboard': 'Any visualization on the %{perspective} that uses the same data source',
	'drillThroughParametersColumnTitle': '"%{targetName}" prompts:',
	'drillThroughMetadataColumnTitle': '"%{boardName}" data columns:',
	'drillThroughDefinitionNoParameter': 'The drill-through target has no prompts.',
	'drillThroughDefinitionErrorQueryingReport': 'Correct the problem with the target report, and then try again to create the drill-through definition.',
	'drillThroughDefinitionErrorDlgTitle': 'Something went wrong',
	'dlg_back': 'Go back',
	'dlg_close': 'Close',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Cancel',
	'dlg_apply': 'Apply',
	'dlg_create': 'Create',
	'dlg_done': 'Done',
	'drillthrough_unsaveMsg': 'Continue without saving "%{name}"?',
	'drillthrough_jumpTo': 'Drill-through definition: %{name}',
	'drillthrough_jumpToLabel': 'Drill through',
	'drillthrough_manage': 'Manage...',
	'drillthrough_addNewTarget': 'Add a new drill-through definition',
	'drillthrough_manageJumpPaths': 'Manage drill-through definitions',
	'drillthrough_manageJumpPaths_edit': 'Edit "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'Delete "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'Add another drill-through definition',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Confirm delete',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Are you sure you want to delete drill-through "%{name}"?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Duplicate drill-through name',
	'drillthrough_definitionMessage': 'Drill-through "%{name}" already exists. Provide a different name',
	'drillthrough_jumpToTarget_notFound': 'Target not found for drill-through "%{name}"',
	'drillThroughDefinitionNoParameterSubTitle': 'No context will be passed to the target report.',
	'drillthrough_titleLabel': 'Name',
	'drillthrough_create_dialogTitle': 'Create drill-through definition',
	'drillthrough_edit_dialogTitle': 'Edit drill-through definition',
	'drillthrough_subTitle': 'The context of the visualization in your source is used to filter the target %{perspective}.',
	'drillthrough_selectColumn': 'Select a column',
	'noPrompt': 'No prompts',
	'promptDialog': '%{promptType} prompt dialog',
	'formatAutoDescription': 'Auto specifies the format inherited from your data source or visualization.',
	'formatDefaultDescription': 'Default specifies the format inherited from the system',
	'createCustomGroupAction': 'Create data group',
	'removeCustomGroupAction': 'Remove data group',
	'editCustomGroupAction': 'Edit data group',
	'renameCustomGroupAction': 'Rename data group',
	'createCustomGroupErrorToast': 'Your data group could not be created.',
	'removeCustomGroupErrorToast': 'Your data group could not be removed.',
	'editCustomGroupErrorToast': 'Your data group could not be edited.',
	'renameCustomGroupErrorToast': 'Your data group could not be renamed.',
	'customGroupLabel': 'Create data group',
	'ungroupCustomGroupLabel': 'Ungroup',
	'renameCustomGroupLabel': 'Rename',
	'createCustomGroupLabel': 'Create',
	'customGroupingLabel': '%{columnLabel} (Group)',
	'createCustomBinningErrorToast': 'Your auto group could not be created.',
	'removeCustomBinningErrorToast': 'Your auto group could not be removed.',
	'createCustomSort': 'Create custom sort',
	'unavaiableData': 'No data',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Select available items then reorder them to create a custom sort.',
	'availableItems': 'Available items',
	'selectAll': 'Select all',
	'customSortOrder': 'Custom sort order',
	'selectAvailableItemsDesc': 'Select available items then reorder them here.',
	'moveToTop': 'Move to top',
	'clear': 'Clear',
	'sortRemainingItemsBy': 'Sort remaining items by',
	'removeAll': 'Remove all',
	'resetTooltip': 'All items will be removed from the %{customSortOrder} list. And, the %{sortRemainingItemsBy} drop-down will revert to the default.',
	'manyItemsWarning': 'Selecting many items may impact the performance of your dashboard.',
	'manyItemsSelected': 'More than %{maxItems} items have been selected, this may impact the performance of your dashboard.',
	'somethingWentWrong': 'Uh oh. Something\'s not quite right.',
	'tryAgain': 'Try again',
	'customSortLabel': 'Custom sort',
	'applyError': 'Unable to apply %{action}.',
	'searchReturnedNoResults': 'Hmm, your search didn\'t return any results.',
	'extVisSystem': 'System',
	'extVisCustom': 'Custom',
	'customVisTestVisualization': 'Test visualization',
	'extVisCustomVisPreview': 'preview',
	'extVisCustomPreviewWidgets': 'Developer widgets',
	'extVisCustomVVisualization': 'Visualization',
	'extVisCustomVisuals': 'Custom visuals',
	'noPermissionToManage': 'You do not have permission to manage custom visualizations.',
	'extVisCustomUpdate': 'Update',
	'extVisCustomDelete': 'Delete',
	'extVisNoCustomVisuals': 'No custom visuals',
	'extVisNoCustomVisualsMsg': 'There are currently no custom visuals in your organization',
	'extVisAddCustomVisual': 'Add a custom visual',
	'extVisNoCustomVisualsAdminMsg': 'There are currently no custom visuals. Add one to get started',
	'extVisNoSDKConnection': 'No connection has been created to your local file',
	'extVisNoSDKPreviewMsg': 'To preview your visualizations, please establish a connection.',
	'extVisMore': 'More',
	'extVisDeleteDialogTitle': 'Delete custom visual',
	'extVisDeleteDialogBody': 'Are you sure you want to delete this custom visualization? This might be in use by other dashboards and reports.',
	'extVisDeleteConfirmation': 'Your custom visual was deleted.',
	'extVisDeleteError': 'Your custom visual could not be deleted. %{msg}',
	'extVisCloseToast': 'Close now',
	'extVisAdd': 'Your custom visual was successfully added.',
	'extVisAddError': 'Your custom visual could not be added. %{msg}',
	'extVisUpdate': 'Your custom visual was successfully updated.',
	'extVisUpdateError': 'Your custom visual could not be updated. %{msg}',
	'extVisAddProgress': 'Importing %{name}',
	'extVisUpdateProgress': 'Updating %{name}',
	'extPermissionTitle': 'Restricted access or deleted custom visual',
	'extPermissionBody': 'This custom visual cannot be viewed because it has either been deleted or has restricted access.',
	'customVizSaveWarning': 'Your custom visuals cannot be saved. They have not been imported.',
	'schematicTestCaption': 'Test schematic',
	'schematicServiceRequestError': 'Schematic service error',
	'extVisPreviewMessage': 'This is a preview. The visualization has not been added to the product yet.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Undefined',
	'kpiDefaultTargetLabel': 'Target',
	'kpiNonNumericTarget': 'The target value must be a number.',
	'kpiManualTargetSlotFilled': 'Value applied in field',
	'kpiAutoValueSize': 'Auto',
	'kpiUnableDrawSparklineLabel': 'Unable to draw sparkline',
	'kpiUnableDrawSparklineInfo': 'A sparkline requires a minimum of two points in time. Change the data or adjust the filters to see the sparkline.',
	'conditionalFormattingTextColor': 'Text color',
	'suppression': 'Suppression',
	'suppressNone': 'None',
	'suppressRowsAndColumns': 'Rows and Columns',
	'suppressRows': 'Rows',
	'suppressColumns': 'Columns',
	'enableSuppression': 'Enable suppression',
	'disableSuppression': 'Disable suppression',
	'loadVisDefinitionError': 'Unable to load definition for visualization %{id}',
	'emptyVisualization': 'Empty visualization',
	'expandCollapse': 'Expand & collapse',
	'expandBtnLabel': 'Expand',
	'collapseBtnLabel': 'Collapse',
	'prop_sizeInputNonNumericValue': 'The value must be a number.',
	'prop_sizeValueShouldBeHigher': 'The value must be greater than %{value}.',
	'fontPropLabel': 'Font family',
	'fontSizePropLabel': 'Font size',
	'sectionItemAxisTitle': 'Item axis title',
	'sectionItemAxisLabel': 'Item axis label',
	'sectionValueAxisTitle': 'Value axis title',
	'sectionValueAxisLabel': 'Value axis label',
	'sectionRepeatColumnTitle': 'Repeat column title',
	'sectionRepeatRowTitle': 'Repeat row title',
	'styletext-widget.legend': 'Legend',
	'styletext-itemAxis.ticks.labels': 'Axis labels',
	'styletext-valueAxis.title': 'Axis titles',
	'styletext-itemAxis.title': 'Axis titles',
	'styletext-labels': 'Data labels',
	'styletext-valueAxis.line.title': 'Line titles',
	'styletext-cellValue': 'Values',
	'styletext-values': 'Values',
	'styletext-rowHeading': 'Row headings',
	'styletext-columnHeading': 'Column headings',
	'regularFontStyle':'Regular',
	'fontFamily': 'family',
	'fontSize': 'size',
	'visExportFileName': 'Visualization',
	'ds-missingDataSet': 'Could not find dataset. Please make sure dataset is created successfully.',
	'ds-missingDashboardId': 'Please save dashboard before creating the dataset.',
	'ds-unsupportedDataSourceType': 'The %{type} data source type is not supported.',
	'dataCache': 'Data cache',
	'dataCache_on': 'On',
	'dataCache_off': 'No cache',
	'dataCache_auto': 'Automatic',
	'queryOptimization': 'Query optimization',
	'propshowDataGridInConsumeMode': 'Show data grid in preview',
	'dtMatchMetadata': 'Use matching metadata to filter the target dashboard.',
	'dtMatchMetadata_info': 'If the target dashboard is based on a different data source, apply filters when metadata identifiers match. This might affect performance.',
	'dtOverrideExistingFilters': 'Override only global filters that are already present in the target dashboard.\nOther filters on the source visualization are ignored.',
	'OnLoadFilterModifierDatasourceMismatch': 'Filters will not be applied to the target because the dashboards are using different sources.',
	'OnLoadFilterModifierColumnMismatch': 'One or more filters were not applied because the matching column(s) could not be found.',
	'showValuesOn': 'Show values on',
	'showValuesAsRowLabel': 'Rows (when best)',
	'showValuesAsColumnLabel': 'Columns (when best)',
	'dropdownMultiSelectClearAll': 'Clear all selections',
	'dropdownSingleSelectClearAll': 'Clear selection',
	'dropdownOpenMenu': 'Open menu',
	'dropdownCloseMenu': 'Close menu',
	'cascadingFiltersSection': 'Cascading filter settings',
	'cascadeStrategy': 'Cascade set strategy',
	'cascadeStrategy_FirstToLast': 'First to last',
	'cascadeStrategy_MultiDirectional': 'Multidirectional',
	'cascade_globalToTab': 'Cascade All tabs filters',
	'cascade_tabToLocal': 'Cascade This tab filters to local',
	'showAllData': 'Show all values',
	'showAllFilterValue': '(%{value})',
	'valuesCascaded': 'Values filtered by All tabs',
	'AnalyticsMsgDefault': 'The widget selected does not use forecasting or analytic insights',
	'AnalyticsDescriptionDefault': 'Select a visualization with analytics support to view and manage the analytics settings.',
	'AnalyticsMsgNoContent': 'No visualization selected',
	'AnalyticsMsgMultiSelected': 'Multiple widgets selected',
	'AnalyticsDescriptionMultiSelected': 'Select one visualization to view and manage the analytics setting for it.',
	'ChartInsightPinnedSectionDescription':'Your favorite narrative insights are also shared when you share the dashboard. Insights might be affected by data changes and are not shown if they do not apply to the current data.',
	'ChartInsightNonPinnedSectionDescription':'Suggested insights are system generated for your visualization. These insights can change if there is a change in the data.',
	'ChartInsightPinnedSectionTitle':'Favorite insights (%{count})',
	'ChartInsightNonPinnedSectionTitle':'Suggested insights (%{count})',
	'ChartInsightPinnedEmpty':'Click the star icon for a suggested insight to add it as a favorite.',
	'ChartInsightAllInsightsPinned': 'No new insights are available or all suggested insights were added to favorites.',
	'ChartInsightNoRecommendedInsights': 'There are no insights for this visualization.',
	'ChartInsightLoadingMessage':'Finding narrative insights for your data',
	'ChartInsightConsumePinnedInsightsDesc': 'The dashboard author has favorited these insights.',
	'MoveUp':'Move insight up',
	'MoveDown':'Move insight down',
	'Star':'Add insight to favorites',
	'Unstar':'Remove insight from favorites',
	'DisabledUnstar': 'Favorited insight',
	'PdfPrintSectionLabel': 'PDF print settings',
	'PdfPrintOptionsLabel': 'Print options',
	'PdfPrintInViewLabel': 'In view',
	'PdfPrintExtendedContentLabel': 'Extended content',
	'PdfPrintNewPageLabel': 'New page'
});
